import { render, staticRenderFns } from "./BatchBindForm.vue?vue&type=template&id=4835fe08&scoped=true"
import script from "./BatchBindForm.vue?vue&type=script&lang=js"
export * from "./BatchBindForm.vue?vue&type=script&lang=js"
import style0 from "./BatchBindForm.vue?vue&type=style&index=0&id=4835fe08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4835fe08",
  null
  
)

export default component.exports